// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmTrackLocator = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			wrapper: '.track-locator',
			selector: '.track-locator__sector',
			activeClass: 'track-locator__sector--active'
		}, options);

		// These are all the methods available for the plugin.
		var methods = {},
		$trackContainer,
		$selector = $(settings.selector),
		timer,
		desktop;

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		// On load function
		methods.initContext = function($context) {
			methods.setCurrentSettings($context);

			// Window onload event required as svg needs to be loaded before the code is run.
			window.onload = function () {
				methods.bind($context);
			}
		}

		methods.bind = function ($context) {
			// Get the SVG content.
			$trackContainer = $context.find('#trackLocator').contents();

			// Add Hover events
			$trackContainer.find('.track-sector').on('mouseout', function () {
				var $this = $(`#${$(this).attr('id')}`);
				// Set timeout
				timer = setTimeout(function() {
					$this.removeClass(settings.activeClass);
				}, 150);
			})
			.on('mouseover', function () {
				// Clear the timeout.
				clearTimeout(timer);
				timer = false;
				// Remove any existing active classes.
				$(`.${settings.activeClass}`).removeClass(settings.activeClass);
				// Add the active class to the info panel
				$(`#${$(this).attr('id')}`).addClass(settings.activeClass);
			});
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);

			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($this);
		});
	};
}(jQuery));
